import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Simplified hook to handle unsaved changes warning
 * For now, this is a placeholder that doesn't actually block navigation
 * Components can still use it but it won't cause the problematic behavior
 *
 * @param {boolean} hasUnsavedChanges - Whether the component has unsaved changes
 * @param {Function} onSave - Async function to save changes (optional)
 * @param {Object} options - Additional options
 * @param {string} options.title - Custom dialog title
 * @param {string} options.message - Custom dialog message
 * @param {boolean} options.enabled - Whether blocking is enabled (default: true)
 */
export const useBlockNavigation = (
  hasUnsavedChanges,
  onSave = null,
  options = {}
) => {
  const navigate = useNavigate();

  // Handle browser beforeunload event
  useEffect(() => {
    if (!hasUnsavedChanges || !options.enabled) {
      return;
    }

    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = options.message || 'You have unsaved changes. Are you sure you want to leave?';
      return e.returnValue;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges, options.enabled, options.message]);

  // Return the navigate function for components to use
  return { navigate };
};

export default useBlockNavigation;